export default __webpack_public_path__ + "static/media/pokerchip_snd.62908a9c.mp3";